module.exports = __webpack_public_path__ + "img/vuejs.c6173a47.svg";